import React from "react";

import "../styles/index.scss";

import background from "../assets/cirrus-graphic-blue.png";
import logo from "../assets/logo.svg";

const Layout = (props: { children: React.ReactNode }) => {
  return (
    <div id="layout">
      <img
        src={background}
        style={{
          position: "fixed",
          maskImage: "linear-gradient(to left, rgba(0,0,0,1), rgba(0,0,0,0))",
          top: 0,
          right: 0,
          height: "100vh",
          width: "auto",
          pointerEvents: "none",
          zIndex: 0,
        }}
      />

      <div id="layout-header">
        <img id="logo" src={logo} />
        <div id="logo-text">Cirrus CRM</div>
      </div>
      <div id="layout-content">{props.children}</div>
    </div>
  );
};

export default Layout;
